import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { getAcademyUrlPublic, getCommunityUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getNonProfitsUrlPublic, getServiceUrlPublic, getStartupsUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { handleClickFrequentlyAskedQuestionLink } from './trackFrequentlyAskedQuestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const communityHref = getCommunityUrlPublic();
const langHref = getLanguagesUrlPublic();
const academyHref = getAcademyUrlPublic();
const kbHref = getKnowledgeBaseUrlPublic();
const serviceHref = getServiceUrlPublic();
const startupsHref = getStartupsUrlPublic('pricing-servicepage');
const nonprofitsHref = getNonProfitsUrlPublic('pricing-servicepage');
export const ServiceHubFaqs = () => {
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whatIsServiceHub.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whatIsServiceHub.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          serviceLink: /*#__PURE__*/_jsx(Link, {
            href: serviceHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'service.whatIsServiceHub',
                url: serviceHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.service.whatIsServiceHub.learnMore"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whatIsFreeVsPaid.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whatIsFreeVsPaid.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.howManyUsers.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.howManyUsers.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.salesVsService.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.salesVsService.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whatSupport.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          communityLink: /*#__PURE__*/_jsx(Link, {
            href: communityHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'service.whatSupport',
                url: communityHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.service.whatSupport.hubSpotCommunity"
            })
          }),
          languageLink: /*#__PURE__*/_jsx(Link, {
            href: langHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'service.whatSupport',
                url: langHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.service.whatSupport.languageOffering"
            })
          }),
          academyLink: /*#__PURE__*/_jsx(Link, {
            href: academyHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'service.whatSupport',
                url: academyHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.service.whatSupport.hubSpotAcademy"
            })
          }),
          kbLink: /*#__PURE__*/_jsx(Link, {
            href: kbHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'service.whatSupport',
                url: kbHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.service.whatSupport.hubSpotKnowledgeBase"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whatDiscounts.answer",
        options: {
          startupsLink: /*#__PURE__*/_jsx(Link, {
            href: startupsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'service.whatDiscounts',
                url: startupsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.service.whatDiscounts.hubSpotStartupsProgram"
            })
          }),
          nonprofitsLink: /*#__PURE__*/_jsx(Link, {
            href: nonprofitsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'service.whatDiscounts',
                url: nonprofitsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.service.whatDiscounts.hubSpotNonprofits"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whenEligibleForNewPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.service.whenEligibleForNewPricing.answer"
      })
    })]
  });
};